import React, { useEffect, useState } from 'react';
import Air from './Air'; // Fallback default
import { getCustomerName } from '../../../helpers';

const customer = getCustomerName()

// Wrapper component to load the appropriate logo based on the customer and variant
const AppBrand = React.forwardRef(({ variant = 'default', ...props }, ref) => {
  const [LogoComponent, setLogoComponent] = useState(() => Air);

  useEffect(() => {
    const logoFile = variant === 'full' ? 'LogoFull.js' : 'Logo.js';
    
    // Load the logo component dynamically based on the customer and variant, with fallback to AIR if not found
    import(`../../../domains/${customer}/${logoFile}`)
      .then((module) => {
        setLogoComponent(() => module.default);
      })
      .catch((error) => {
        console.warn(`No ${logoFile} found for customer ${customer}, using AIR default`, error);
        setLogoComponent(() => Air);
      });
  }, [variant]);

  return <LogoComponent ref={ref} {...props} />;
});

AppBrand.displayName = 'AppBrand';

export default AppBrand;
